import { useTranslation } from 'react-i18next';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function TermsOfServicePage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-8">
            {t('termsTitle')}
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6">
              <strong>{t('termsLastUpdated')}</strong>
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">{t('termsSection1Title')}</h2>
              <p className="text-gray-600 mb-4">{t('termsSection1Text1')}</p>
              <p className="text-gray-600 mb-4">{t('termsSection1Text2')}</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">{t('termsSection2Title')}</h2>
              <p className="text-gray-600 mb-4">{t('termsSection2Text1')}</p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-4">
                <li>{t('termsSection2Item1')}</li>
                <li>{t('termsSection2Item2')}</li>
                <li>{t('termsSection2Item3')}</li>
                <li>{t('termsSection2Item4')}</li>
                <li>{t('termsSection2Item5')}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">{t('termsSection3Title')}</h2>
              <p className="text-gray-600 mb-4">{t('termsSection3Text1')}</p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-4">
                <li>{t('termsSection3Item1')}</li>
                <li>{t('termsSection3Item2')}</li>
                <li>{t('termsSection3Item3')}</li>
                <li>{t('termsSection3Item4')}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">{t('termsSection4Title')}</h2>
              <p className="text-gray-600 mb-4">{t('termsSection4Text1')}</p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-4">
                <li>{t('termsSection4Item1')}</li>
                <li>{t('termsSection4Item2')}</li>
                <li>{t('termsSection4Item3')}</li>
                <li>{t('termsSection4Item4')}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">{t('termsSection5Title')}</h2>
              <p className="text-gray-600 mb-4">{t('termsSection5Text1')}</p>
              <p className="text-gray-600 mb-4">{t('termsSection5Text2')}</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">{t('termsSection6Title')}</h2>
              <p className="text-gray-600 mb-4">{t('termsSection6Text1')}</p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-4">
                <li>{t('termsSection6Item1')}</li>
                <li>{t('termsSection6Item2')}</li>
                <li>{t('termsSection6Item3')}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">{t('termsSection7Title')}</h2>
              <p className="text-gray-600 mb-4">{t('termsSection7Text1')}</p>
              <p className="text-gray-600 mb-4">{t('termsSection7Text2')}</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">{t('termsSection8Title')}</h2>
              <p className="text-gray-600 mb-4">{t('termsSection8Text1')}</p>
              <p className="text-gray-600 mb-4">{t('termsSection8Text2')}</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">{t('termsSection9Title')}</h2>
              <p className="text-gray-600 mb-4">{t('termsSection9Text1')}</p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                10. {t('termsSection10Title')}
              </h2>
              <p className="text-gray-700 mb-6">
                {t('termsSection10Content')}
              </p>
              
              <div className="bg-gradient-to-br from-teal-50 to-amber-50 border-l-4 border-teal-500 rounded-lg p-6 shadow-md">
                <h3 className="text-xl font-bold text-gray-900 mb-4">FARWAYS</h3>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <i className="ri-phone-line text-teal-600 text-xl mr-3 mt-1"></i>
                    <div>
                      <a href="tel:+351937545000" className="text-gray-800 font-semibold hover:text-teal-600 cursor-pointer">
                        +351 937 545 000
                      </a>
                      <p className="text-xs text-gray-600">(Custo de uma chamada para a rede móvel nacional)</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <i className="ri-mail-line text-teal-600 text-xl mr-3 mt-1"></i>
                    <a href="mailto:geral@farways.pt" className="text-gray-800 font-semibold hover:text-teal-600 cursor-pointer">
                      geral@farways.pt
                    </a>
                  </div>
                  
                  <div className="flex items-start">
                    <i className="ri-map-pin-line text-teal-600 text-xl mr-3 mt-1"></i>
                    <div className="text-gray-800">
                      <p className="font-semibold">Rua João de Deus, 28C</p>
                      <p>8000-368 Faro, Portugal</p>
                    </div>
                  </div>

                  <div className="border-t border-teal-200 pt-3 mt-4">
                    <p className="text-sm text-gray-700">
                      <strong>FARWAYS</strong> - Marca registada de Alves e Frade, Lda.
                    </p>
                    <p className="text-sm text-gray-700 mt-1">
                      <strong>NIPC:</strong> 505413850 | <strong>RNAVT:</strong> 8586
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
